/**
 * Created by harry.preiss on 01 Feb 2021
 */

import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import {MdbsCore} from "@/api/tsclient";

const utilityClient = new MdbsCore.UtilityClient();

@Module({namespaced: true, name: 'utility', store: store})
export default class UtilityModule extends BaseModule {
    private initialized: boolean = false;
    private environment: string = "";

    get aspNetCoreEnvironment() {
        return this.environment;
    }

    @Mutation
    private setAspNetCoreEnvironment(value: string) {
        this.environment = value;
    }

    @Mutation
    setInitialized(initialized: boolean) {
        this.initialized = initialized;
    }

    @Action
    async initialize() {
        if (!this.initialized) {
            this.setAspNetCoreEnvironment(await utilityClient.getEnvironment());
            this.setInitialized(true);
        }
    }
}